import { forwardRef } from 'react';

import { TRACK_TYPE, VBaseTrack, type VBaseTrackType } from '../VBaseTrack';
import VInnerProgressBar from './VInnerProgressBar';
import type { VProgressBarProps } from './type';

const VProgressBar = <T extends VBaseTrackType = TRACK_TYPE.NORMAL>(
  {
    disabled,
    max = 100,
    min = 0,
    readOnly,
    step = 1,
    type = TRACK_TYPE.NORMAL as T,
    value,
    ...rest
  }: VProgressBarProps<T>,
  ref: React.Ref<HTMLDivElement>,
) => {
  const baseProps = {
    disabled,
    max,
    min,
    readOnly,
    step,
    type,
    value: value ?? (type === TRACK_TYPE.NORMAL ? 0 : []),
  } as VProgressBarProps<T>;

  return (
    <VBaseTrack {...baseProps}>
      <VInnerProgressBar ref={ref} {...rest} />
    </VBaseTrack>
  );
};

export default forwardRef(VProgressBar) as <
  T extends TRACK_TYPE | Lowercase<TRACK_TYPE> = TRACK_TYPE.NORMAL,
>(
  props: VProgressBarProps<T> & {
    ref?: React.ForwardedRef<HTMLDivElement>;
  },
) => ReturnType<typeof VProgressBar>;
